export default __webpack_public_path__ + "static/media/1.6fb42d60.webp";